import axios from "axios";
import { registerApiErrorReport } from "../Components/Errors/errorReporter";
const checkEnvironment = (url, apiUrl) => {
  const Environment = process.env.NODE_ENV;
  if (Environment === "development") return url + apiUrl;
  if (Environment === "production")
    return window.env.REACT_APP_API_HOST + apiUrl;
};
const _basic = window.env.REACT_APP_API_DEVELOPMENT_HOST;
const _order = "/Order";
const order = axios.create({
  baseURL: checkEnvironment(_basic, _order)
});
const CancelToken = axios.CancelToken;

registerApiErrorReport(order);


export const postTranslationOrder = async orderData => {
  return await order.post("/TranslationOrder", orderData);
};

export const postCreateOrder = async orderData => {
  return await order.post("/CreateOrder", orderData);
};

let cancelShareOrderDetail;
export const getShareOrderDetail = async (orderCode, langId, storeID, createAt) => {
  return await order
    .get("/ShareOrderDetail", {
      params: {
        orderCode: orderCode,
        languageID: langId,
        storeID,
        createAt
      },
      cancelToken: new CancelToken(cancellation => {
        cancelShareOrderDetail = cancellation;
      })
    })
    .catch(err => {
      if (axios.isCancel(err)) {
        // throw err
        console.log("cancel");
      } else {
        throw err;
      }
    });
};

/**
 * 新增或更新暫存訂單
 * @param {*} saveData
 */
 export const saveTempOrder = async saveData => {
  return await order.post("/saveTempOrder", saveData).catch(err => {
    throw err;
  });
};

/**
 * 重印預點單
 * @param {string} tempOrderGroupID
 * @param {string} languageID
 * @param {number} storeID
 * @param {string} createAt
 * @param {string} tableNo
 */
 export const GetTempOrderDetail = async (tempOrderGroupID, languageID, storeID, createAt, tableNo) => {
  return await order.get("/GetTempOrderDetail", {
    params: {
      tempOrderGroupID,
      languageID,
      storeID,
      createAt,
      tableNo
    }
  });
};

export const postCreateAddOrder = async orderData => {
  return await order.post("/CreateAddOrder", orderData);
};

export { cancelShareOrderDetail };
